<template>
	<div class="text-uppercase">
		<div class="panel panel-custom">
			<div class="panel-heading">
				<strong>AGENDAMENTO #{{ agendamento.horas[0].agendamento.id }}</strong>
				<a :href="`${base_url}/agenda/${agendamento.horas[0].agendamento.id}/downloadProtocolo`" target="_blank" class="btn btn-info pull-right">Protocolo</a>
			</div>
			<div class="panel-body">
				<!-- success messages -->
				<div class="alert alert-success" v-if="successMessage">
					<strong>{{ successMessage }}</strong>
				</div>

				<!-- error messages -->
				<div class="alert alert-danger" v-if="errorMessage || agendamento.horas[0].agendamento.alteracao">
					<strong>{{ errorMessage || agendamento.horas[0].agendamento.alteracao }}</strong>
				</div>

				<form @submit.prevent="preSave">
					<fieldset :disabled="agendamento.horas[0].agendamento.alteracao">
						<v-input
							type="tel"
							label="AGENDADO EM"
							:value="`${agendamento.horas[0].agendamento.dataAgendamento}`"
							disabled
						></v-input>

						<v-input
							type="tel"
							label="AGENDADO PARA"
							:value="`${agendamento.data} ${agendamento.horas[0].hora}`"
							disabled
						></v-input>

						<v-select
							label="ASSUNTO"
							v-model="form.assuntoAgendamento"
							option-text="nome"
							:options="assuntosAgendamento"
						></v-select>

						<v-textarea
							label="DESCRIÇÃO DO ASSUNTO"
							v-model="form.descricaoAssunto"
							rows="3"
							maxlength="200"
							:error-message="validate('isNotBlank', form.descricaoAssunto, 'Preenchimento obrigatório')"
						></v-textarea>

						<template v-if="confirmingCancel">
							<form @submit.prevent="cancel" class="form-horizontal">
								<div class="form-group" style="margin-bottom:-1px;">
									<div class="col-xs-6">
										<label class="text-uppercase" style="line-height:35px;margin-bottom:0px">Cancelar?</label>
									</div>
									<div class="col-xs-6 text-right">
										<button type="button" class="btn btn-danger" @click="confirmingCancel = false">NÃO</button>
										<button type="submit" class="btn btn-success">SIM</button>
									</div>
								</div>
							</form>
						</template>
						<template v-else-if="confirmingSave === false">
							<button type="button" class="btn btn-danger" @click="confirmingCancel = true">CANCELAR</button>
						</template>

						<template v-if="confirmingSave">
							<form @submit.prevent="save" class="form-horizontal">
								<div class="form-group" style="margin-bottom:-1px;">
									<div class="col-xs-6">
										<label class="text-uppercase" style="line-height:35px;margin-bottom:0px">Salvar?</label>
									</div>
									<div class="col-xs-6 text-right">
										<button type="button" class="btn btn-danger" @click="confirmingSave = false">NÃO</button>
										<button type="submit" class="btn btn-success">SIM</button>
									</div>
								</div>
							</form>
						</template>
						<template v-else-if="confirmingCancel === false">
							<button type="submit" class="btn btn-success pull-right">SALVAR</button>
						</template>
					</fieldset>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery';
	import moment from 'moment';
	import Form from 'helpers/form';
	import Agenda from 'models/agenda';
	import rules from 'helpers/validationRules';

	export default {
		props: ['agendamento'],

		data() {
			let agendamento = this.agendamento.horas[0].agendamento;

			return {
				confirmingCancel: false,
				confirmingSave: false,
				validating: false,
				successMessage: '',
				errorMessage: '',
				assuntosAgendamento: '',
				base_url: Config.BASE_URL,

				form: new Form(agendamento)
			};
		},

		async created() {
			let assuntosAgendamento = await Agenda.getAssuntosAgendamento();

			// deixa no mesmo formato que o form.assuntoAgendamento para compatibilidade com o helper VSelect
			this.assuntosAgendamento = assuntosAgendamento.map(a => {
				return {
					id: a.id,
					nome: a.nome
				};
			});
		},

		computed: {
			data() {
				return moment(this.$route.params.data, 'DD-MM-YYYY-HH:mm:ss').format('DD [de] MMMM [de] YYYY HH:mm');
			}
		},

		methods: {
			validate(rule, value, arg, message) {
				if (message === undefined) {
					message = arg;
				}

				if (this.validating) {
					return rules[rule](value, arg) ? '' : message;
				}
			},

			hasValidationErrors() {
				let fields = $('.has-error');

				return fields.length > 0;
			},

			preSave() {
				this.validating = true;
				this.errorMessage = '';

				this.$nextTick(() => {
					if (this.hasValidationErrors() === false) {
						this.confirmingSave = true;
					} else {
						let firstErrorField = $('.has-error:first');

						window.scrollTo(0, firstErrorField.position().top);
					}
				});
			},

			save() {
				let url = `${Config.BASE_URL}/agenda/${this.agendamento.horas[0].agendamento.id}`;

				this.validating = false;
				this.confirmingSave = false;

				delete this.form.dataAgendamento;

				this.form.save(url)
					.then(() => {
						// this.$router.push('/agendamentos');
						this.successMessage = 'Agendamento atualizado com sucesso!';
					})
					.catch(error => {
						this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;
					})
					.done(() => {
						setTimeout(() => {
							this.errorMessage = '';
							this.successMessage = '';
						}, 5000);
					});
			},

			cancel() {
				this.confirmingCancel = false;

				Agenda.cancelarAgendamento(this.agendamento.horas[0].agendamento.id)
					.then(() => {
						this.$emit('done');
					})
					.catch(error => {
						this.errorMessage = error.responseJSON.message || error.responseJSON.errorMessage;
					})
					.done(() => {
						setTimeout(() => {
							this.errorMessage = '';
						}, 5000);
					});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// agendamento.vue?02a6b6a4